import {ReferenceNodeGenericTypeMap, ReferenceNodeType} from "~/enums/referenceNodeType"
import { GenericType } from '~/interfaces/genericTypeInterfaces';
import { IReferencePathNodeSpecific, IReferenceWorkflowStepDate } from "~/interfaces/referencePathInterfaces";
import ReferencePathService from "~/services/referencePathServices/referencePathService";
import WorkflowStep from '../../../formability/form_builder/models/workflow/workflowStep';
import {ModelType} from '~/enums/modelType'

export class WorkflowStepDatePathService extends ReferencePathService {
  get imposterModelType(): ModelType {
    return this.referenceGenericModelType
  }

  constructor(private workflowStepDateNode: IReferenceWorkflowStepDate) {
    super();
  }

  get label(): string {
    switch (this.workflowStepDateNode.reference_type) {
      case ReferenceNodeType.WorkflowStepStart:
        return `${this.reference()?.titleOrDefault} Step Start Date`
      case ReferenceNodeType.WorkflowStepEnd:
        return `${this.reference()?.titleOrDefault} Step Completion Date`
      default:
        this.referenceTypeError('DatePathService#label', this.workflowStepDateNode);
        break;
    }
  }

  get nodes(): IReferenceWorkflowStepDate[] {
    return [this.workflowStepDateNode];
  }

  reference(): WorkflowStep {
    const id = this.workflowStepDateNode.reference_id.split("_")[0]
    return WorkflowStep.repo.findById(id);
  }

  get referenceGenericModelType(): GenericType {
    return ReferenceNodeGenericTypeMap[this.workflowStepDateNode.reference_type]
  }

  get referenceModelType(): ModelType {
    return this.referenceGenericModelType
  }

  canLinkTo(node: IReferencePathNodeSpecific): boolean {
    let decision = !node // nothing can be linked to it - end of the line
    this.debugCanLinkTo('WorkflowStepDataPathService', this.workflowStepDateNode, node, decision)
    return decision
  }

  referenceIsCollection = false
}